export const isOrderCancelled = (o) => {
    return ['cancelled'].includes(o.order_status);
};
